// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import { Box, Button, Text } from 'gestalt';

type Props = {|
  onHide: () => void,
|};

function PasswordChangeSuccessModal({ onHide }: Props) {
  const titleText = i18n._('Password Changed!');
  return (
    <Modal
      accessibilityCloseLabel={i18n._('Close')}
      accessibilityModalLabel={titleText}
      onDismiss={onHide}
      heading={titleText}
      footer={
        <Box display="flex" alignItems="center" justifyContent="end">
          <Button color="red" inline onClick={onHide} text={i18n._('Okay')} size="md" />
        </Box>
      }
    >
      <Box padding={4}>
        <Text>{i18n._('Your password has been changed successfully.')}</Text>
      </Box>
    </Modal>
  );
}

export default PasswordChangeSuccessModal;
